import type { DynamicInvoicePageRevisionedLineItem } from '@weft/api-definition';
import type { PromotionLineItem } from '@weft/types';
import React from 'react';
import type { QueryKey } from 'react-query';
import { FixedRevisionedLineItemDialogForm } from '../revisioned-line-item-dialog-forms/FixedRevisionedLineItemDialogForm';
import { PromotionRevisionedLineItemDialogForm } from '../revisioned-line-item-dialog-forms/PromotionRevisionedLineItemDialogForm';
import type { DialogsState } from '../revisioned-line-item-dialog-types/dialogs-state';
import type { RevisionedLineItemDialogType } from '../revisioned-line-item-dialog-types/revisioned-line-item-dialog-type';
import { RevisionedLineItemDialogs } from '../revisioned-line-item-dialog-types/revisioned-line-item-dialog-type';
import { RevisionedLineItemDialogSubmitActions } from '../RevisionedLineItemDialogForm';

type RevisionedLineItemsDialogsSectionProps = {
  invoiceId: string;
  dialogsState: DialogsState;
  setDialogsState: React.Dispatch<React.SetStateAction<DialogsState>>;
  queryKeyToInvalidate?: QueryKey;
  revisionedLineItems: DynamicInvoicePageRevisionedLineItem[]
  promotionLineItems: PromotionLineItem[]
};

export const RevisionedLineItemsDialogsSection: React.FC<RevisionedLineItemsDialogsSectionProps> = ({ invoiceId, promotionLineItems, revisionedLineItems, dialogsState, setDialogsState, queryKeyToInvalidate }) => {
  const handleDialogVisibility = (dialogName: RevisionedLineItemDialogType, visible: boolean) => {
    return () => {
      setDialogsState((previousState) => ({
        ...previousState,
        [dialogName]: {
          ...previousState[dialogName],
          open: visible,
        },
      }));
    };
  };

  return (
    <>
      <FixedRevisionedLineItemDialogForm
        key={dialogsState[RevisionedLineItemDialogs.Fixed].lineItemId}
        revisionedLineItemId={dialogsState[RevisionedLineItemDialogs.Fixed].lineItemId}
        open={dialogsState[RevisionedLineItemDialogs.Fixed].open}
        onClose={handleDialogVisibility(RevisionedLineItemDialogs.Fixed, false)}
        invoiceId={invoiceId}
        defaultValues={dialogsState[RevisionedLineItemDialogs.Fixed].defaultValues}
        submitAction={dialogsState[RevisionedLineItemDialogs.Fixed].lineItemId ? RevisionedLineItemDialogSubmitActions.Update : RevisionedLineItemDialogSubmitActions.Create}
        queryKeyToInvalidate={queryKeyToInvalidate}
      />

      <PromotionRevisionedLineItemDialogForm
        key={dialogsState[RevisionedLineItemDialogs.Promotion].lineItemId}
        revisionedLineItemId={dialogsState[RevisionedLineItemDialogs.Promotion].lineItemId}
        open={dialogsState[RevisionedLineItemDialogs.Promotion].open}
        onClose={handleDialogVisibility(RevisionedLineItemDialogs.Promotion, false)}
        invoiceId={invoiceId}
        revisionedLineItems={revisionedLineItems}
        promotionLineItems={promotionLineItems}
        defaultValues={dialogsState[RevisionedLineItemDialogs.Promotion].defaultValues}
        submitAction={dialogsState[RevisionedLineItemDialogs.Promotion].lineItemId ? RevisionedLineItemDialogSubmitActions.Update : RevisionedLineItemDialogSubmitActions.Create}
        queryKeyToInvalidate={queryKeyToInvalidate}
      />
    </>
  );
};
